import { render, staticRenderFns } from "./Configuracao.vue?vue&type=template&id=6d20d14c&"
import script from "./Configuracao.vue?vue&type=script&lang=js&"
export * from "./Configuracao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports